import React, { useEffect } from 'react';
import { Button as ANTDButton, notification, Skeleton, Empty } from 'antd';
import { getUsersRole, formatAmount } from 'utils/services';
import ShortenId from 'components/Atom/ShortenId';
import StatusTag from 'components/Atom/StatusTag';
import { Button, ResetButton } from '../../components/Atom/Button';
import http from 'utils/http';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { Breadcrumbs } from '../../components/Atom/breadcumbs';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { CautionIcon } from 'assets/icons';
import { TIMEZONES } from 'utils/constant';
import { formatInTimeZone } from 'date-fns-tz';
const PaymentLinkDetail = () => {
  const { isPlatformAccount } = getUsersRole();
  const location = useLocation();
  const navigate = useNavigate();
  const store = useSelector((state) => state.company.store);
  const { id } = useParams();

  const fetchPaymentLinkData = async () => {
    try {
      const storeId = location?.state?.record?.store_id || store?._id;
      const paymentLink_id = id || location?.state?.record?._id;
      const response = await http.get(`/public/v1/payment/link/data/${paymentLink_id}?store_id=${storeId}`);
      const data = response?.data?.data;
      return data;
    } catch {
      return null;
    }
  };

  const {
    data: paymentLinkData,
    refetch,
    isLoading,
    isFetching,
  } = useQuery(`paymentlink_${id || location?.state?.record?.product_id}`, fetchPaymentLinkData, {
    enabled: false,
    manual: true,
  });
  useEffect(() => {
    refetch();
  }, [store]);

  const time_zone = store?.settings?.timezone || TIMEZONES.PKT;
  const structuredData = (item) => {
    const summary = {
      obj: [
        { label: 'Order ID', value: <ShortenId value={paymentLinkData?.order_id || 'N/A'} /> },
        { label: 'Link ID', value: <ShortenId value={paymentLinkData?._id || 'N/A'} /> },
        { label: 'Source', value: item?.source === 'custom-payment-shopify' ? 'Shopify Payment' : 'Custom Payment' },
        { label: 'Customer Name', value: item?.customer_details?.name || 'N/A' },
        ...(item?.customer_details?.email ? [{ label: 'Email', value: item?.customer_details?.email ?? 'N/A' }] : []),
        ...(item?.customer_details?.phone ? [{ label: 'Phone Number', value: item?.customer_details?.phone ?? 'N/A' }] : []),
        ...(item?.source !== 'custom-payment-shopify'
          ? [
              ...(item?.description ? [{ label: 'Description', value: item?.description ?? 'N/A' }] : []),
              {
                label: 'Order Amount',
                value: item?.order_details?.order_amount ? formatAmount(item?.order_details?.order_amount, item?.order_details?.currency) : 'N/A',
              },
              {
                label: 'Currency',
                value: item?.order_details?.currency ? item?.order_details?.currency : 'N/A',
              },
            ]
          : [
              {
                label: 'Inventory Behavior',
                value: item?.inventory_behaviour ?? 'N/A',
              },
              {
                label: 'Reference Id',
                value: item?.reference_id ?? 'N/A',
              },
            ]),
        { label: 'Payment Link', value: item?.shortUrl ?? 'N/A' },
        { label: 'Status', value: <StatusTag tag={item?.status?.toUpperCase()} /> || 'N/A' },
        { label: 'Payment Link Usage Type', value: item?.multipleUse ? 'Multiple Use' : 'One Time Use' },
        { label: 'Creation Time', value: item?.createdAt ? formatInTimeZone(item?.createdAt, time_zone, 'MMM d, yyyy h:mm:ss a') : '-' },
        { label: 'Update Time', value: item?.updatedAt ? formatInTimeZone(item?.updatedAt, time_zone, 'MMM d, yyyy h:mm:ss a') : '-' },

        ...(item?.linkedAccount?.merchant_id
          ? [
              { label: isPlatformAccount ? 'Merchant Id' : 'Initiator Id', value: isPlatformAccount ? item?.linkedAccount?.merchant_id ?? '-' : item?.user_id ?? '-' },
              {
                label: isPlatformAccount ? 'Merchant Store Name' : 'Initiator Store Name',
                value: isPlatformAccount
                  ? item?.linkedAccount?.merchantStoreId?.name
                    ? item?.linkedAccount?.merchantStoreId?.name
                    : item?.linkedAccount?.merchantStoreId?.domain ?? '-'
                  : item?.linkedAccount?.platformStoreId?.name
                  ? item?.linkedAccount?.platformStoreId?.name
                  : item?.linkedAccount?.platformStoreId?.domain ?? '-',
              },
            ]
          : []),
        ...(item?.multipleUse
          ? [
              { label: 'Link usage limit', value: item?.linkUsageLimit ?? '-' },
              { label: 'No. of Time Link Used', value: item?.linkUsed ?? '-' },
              { label: 'Link Expiry Time', value: item?.setExpiry ? item?.setExpiry : '-' },
            ]
          : []),
      ],
    };
    return summary?.obj;
  };
  const data = structuredData(paymentLinkData);

  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'XPay',
        href: '/xpay',
      },
      {
        name: 'Payment Link',
        href: '/paymentlink',
        data: { id: location?.state?.id, isRedirection: true, filtersData: location?.state?.filtersData, searchValue: location?.state?.searchValue },
      },
      {
        name: <ShortenId value={id || location?.state?.id || 'Not Found'} />,
      },
    ],
  };

  const expirePaymentLink = async () => {
    try {
      const response = await http.delete(`/public/v1/payment/link/expire/${paymentLinkData?.store_id}/${paymentLinkData?._id}`);
      notification.success({ message: 'Payment Link Expired Successfully', placement: 'bottomRight' });
      navigate('/paymentlink');
    } catch (err) {
      notification.error({ message: err?.response?.data?.message || 'Something Went Wrong', placement: 'bottomRight' });
    }
  };
  return (
    <>
      <div className='header-container p-4 custom-sticky'>
        <div className='payment-breadcrums'>
          <div
            className='back-button'
            onClick={() =>
              navigate('/paymentlink', {
                state: {
                  id: location?.state?.id,
                  isRedirection: true,
                  filtersData: location?.state?.filtersData,
                  searchValue: location?.state?.searchValue,
                },
              })
            }>
            <ArrowLeftOutlined /> <span style={{ fontWeight: 600 }}>Back</span>
          </div>
          <span style={{ color: '#8C8C8C' }}>|</span>
          <Breadcrumbs {...breadcrumbProps} />
          <ResetButton onClick={refetch} loading={isFetching} />
        </div>
        <div className='detail-heading mt-4'>Payment Link Detail</div>
      </div>

      <div className='custom-panel breakWord payment-Link'>
        {isLoading ? (
          <Skeleton.Input className='payment-skeleton' />
        ) : !paymentLinkData ? (
          store?.isSelected ? (
            <div className='empty-custom-style'>
              <Empty image={Empty?.PRESENTED_IMAGE_SIMPLE} />
            </div>
          ) : (
            <div className='empty-custom-style'>
              <Empty description={'Select store from the drop-down menu above'} />
            </div>
          )
        ) : (
          <>
            <div className='details-section'>
              <div className='heading-section'>
                <h3>Details</h3>
              </div>

              <div className='detail-card'>
                {data?.map((info, index) => (
                  <div key={index} className='detail-value'>
                    <h2>{info?.label}</h2> <span>{info?.value || 'N/A'}</span>
                  </div>
                ))}
              </div>
              {paymentLinkData?.linkedAccount?.merchant_id && (
                <div className='p-3 bg-white' style={{ width: '100%' }}>
                  <div className='bg-[#FFFBE6] gap-3 p-3 rounded-lg flex border border-[#FFE58F]'>
                    <div className='mt-[2px]'>
                      <CautionIcon />
                    </div>
                    <div>
                      {isPlatformAccount ? 'This payment link is generated on behalf of above mentioned merchant account.' : 'This payment link is generated by above mentioned initiator account.'}
                    </div>
                  </div>
                </div>
              )}
            </div>
            {paymentLinkData?.multipleUse && paymentLinkData?.status !== 'complete' && paymentLinkData?.status !== 'expired' && (
              <div className='flex' style={{ justifyContent: 'right', gap: '16px' }}>
                <Button block className='primaryBtn rounded-lg button-size' onClick={expirePaymentLink}>
                  Expire Link
                </Button>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};
export default PaymentLinkDetail;
